export default __webpack_public_path__ + "static/media/default.50c1fc4e4cd918600c601ec32ec0edd8.svg";